import { render } from "./TradingIndexDashboardListCmp.vue?vue&type=template&id=6158c9de"
import script from "./TradingIndexDashboardListCmp.vue?vue&type=script&lang=js"
export * from "./TradingIndexDashboardListCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__